module.exports = __webpack_public_path__ + "img/wti1.4fb4ac92.png";